import { Subject } from 'rxjs';
import * as i0 from "@angular/core";
var VisibleMqService = /** @class */ (function () {
    function VisibleMqService() {
        var _this = this;
        this.currentMediaChangedSource = new Subject();
        this.currentMediaChanged$ = this.currentMediaChangedSource.asObservable();
        this.currentMedia = {
            matches: false,
            media: '',
            className: ''
        };
        this.visibleMediaQueries = {
            'visible-xs': window.matchMedia('(max-width: 567px)'),
            'visible-sm': window.matchMedia('(min-width: 568px) and (max-width: 767px)'),
            'visible-md': window.matchMedia('(min-width: 768px) and (max-width: 1199px)'),
            'visible-lg': window.matchMedia('(min-width: 1200px)')
        };
        this.getVisibleMedia = function () {
            this.currentMedia.matches = false;
            this.currentMedia.media = this.currentMedia.className = '';
            for (var i in this.visibleMediaQueries) {
                if (this.visibleMediaQueries.hasOwnProperty(i) && this.visibleMediaQueries[i].matches) {
                    this.currentMedia.matches = true;
                    this.currentMedia.media = this.visibleMediaQueries[i].media;
                    this.currentMedia.className = i;
                    break;
                }
            }
            this.currentMediaChangedSource.next(this.currentMedia);
        };
        for (var i in this.visibleMediaQueries) {
            if (this.visibleMediaQueries.hasOwnProperty(i)) {
                this.visibleMediaQueries[i].addListener(function (e) { return _this.getVisibleMedia(); });
            }
        }
        this.getVisibleMedia();
    }
    VisibleMqService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function VisibleMqService_Factory() { return new VisibleMqService(); }, token: VisibleMqService, providedIn: "root" });
    return VisibleMqService;
}());
export { VisibleMqService };
